
<div class="min-h-screen flex flex-column surface-ground">

  <nav-bar *ngIf="showNavBar" style="z-index: 1000"></nav-bar>

  <router-outlet style="z-index: 500"></router-outlet>

  </div>